import { useSuspenseQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { APIErrorResponseGenerator } from '@/lib/helper';
import { eventTracker } from '@/lib/service-workers';

import { showToast } from '@/components/@base/toast/show-toast';
import Options from '@/components/app/product/helpers/hooks/type';
import {
  getSingleProductOptions,
  usePostQuestion,
} from '@/components/app/product/services/hooks';
import { useGetProfile } from '@/components/layout/services/hooks';

import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

export default function useAddQuestion({
  slug,
  productId,
  parentId,
  onUpdateQuestionList,
  formRef,
}: Options) {
  const { mutate: postQuestion, isPending: isPostQuestionPending } = usePostQuestion();
  const { profile } = useGetProfile();
  const { data: product } = useSuspenseQuery(getSingleProductOptions(slug));

  const addComment = (content: string) => {
    postQuestion(
      {
        content: content,
        product_id: productId,
        parent_id: parentId,
      },
      {
        onSuccess: (res) => {
          eventTracker(profile?.mobile, 'review_submit', new Date().toISOString(), {
            comment: content,
            product: product.id,
            category: product?.categories?.map((item) => ({
              $oid: item?.id,
            })),
          });

          showToast({ message: productLocalization.addQuestionSuccess, type: 'success' });
          onUpdateQuestionList && onUpdateQuestionList(res.payload);
          if (formRef && formRef.current) {
            formRef.current.reset();
          }
        },
        onError: (postCommentError) => {
          if (postCommentError instanceof AxiosError) {
            showToast(APIErrorResponseGenerator(postCommentError));
          }
        },
      },
    );
  };

  return { addComment, isLoading: isPostQuestionPending };
}
